import i18n from "../../i18n";


const changeLanguage = (lng: string) => {
    window.location.href = `${window.location.origin}${window.location.pathname}?lng=${lng}`;
};

export const LanguageSelector: React.FC = () => {
    return (
        <div style={{ position: "fixed", top: 10, right: 10, zIndex: 1001, backgroundColor: "#FFF", padding: "10px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)", borderRadius: "5px" }}  >
            <div className="d-flex justify-content-start gap-1" style={{ marginBottom: "0.5em" }}>
                <select className="d-inline-block w-auto m-0" defaultValue={i18n.language} onChange={(e) => changeLanguage(e.target.value)}>
                    <option value="en">English</option>
                    <option value="fr">Français</option>
                    <option value="it">Italiano</option>
                    <option value="de">Deutsch</option>
                    <option value="es">Español</option>
                    <option value="tr">Türkçe</option>
                    <option value="pl">Polski</option>
                </select>
                <button style={{ flexShrink: 0 }} onClick={() => changeLanguage("en")}>Reset</button>
            </div>
            Language: {i18n.language}
        </div>
    )
}  